import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { LabelValueCard, PageLoader } from '../../../../shared_elements';
import { Grid, Paper, Tooltip } from '@material-ui/core';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import moment from 'moment';
import { displayDateFormat } from '../../../../constants';
import EditDeliveryCndCard from './EditDeliveryCndCard';
export default function DeliveryCndCard({props}) {
  const [editModal, setEditModal] = useState({ modal: false });
  const [deliveryCndCard, SetDeliveryCndcard] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState({});
  
  useEffect(() => {
    getDeliveryCndCard();
  }, [])
  const toggleEditSideBar = (data) => {
    setEditModal({ modal: true, data: deliveryCndCard })
  }
  const getDeliveryCndCard = () => {
    setLoading(true);
    globalGetService(`/contracts/contract-details/${props.params.contract_slug}/`)
      .then((response) => {
        setLoading(false);
        if (checkApiStatus(response)) {
          SetDeliveryCndcard(response?.data.data);
        }else{
            toastFlashMessage(response?.data.message, 'error');
        }
      })
  }
  const updateDeliveryCndCard = (data, type, assetViewId) => {
    setLoading(true);
    globalPutService(`contracts/contract-details/${props.params.contract_slug}/`, data)
      .then(response => {
        if (checkApiStatus(response)) {
          setEditModal({ modal: false });
          getDeliveryCndCard();
          setLoading(false);
          toastFlashMessage('Delivery Condition Details Updated Successfully', 'success');
        } else {
          setLoading(false);
          toastFlashMessage('Error Occured while updating Delivery Condition Details', 'error');
        }
      }
      )
  }
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return (
    <>
    <div className="data-invoice-block" style={{marginTop:'16px'}}>
      {checkPermission('contracts','delivery_conditions', 'U') ?
      <h5 className="para">
        <Tooltip title="Edit Delivery Condition Details" placement="top">
          <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" className="editIcon" src={editIconWhite} alt="img" />
        </Tooltip>
      </h5>:null}
      <Row>
          <InvoiceConfigCol
            size="2"
            title="Delivery Location"
            value={deliveryCndCard?.titan_extra_fields?.delivery_location||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Actual Delivery Date"
            value={deliveryCndCard?.titan_extra_fields?.actual_delivery_date ? moment(deliveryCndCard?.titan_extra_fields?.actual_delivery_date).format(displayDateFormat) : '--'}
          />
          <InvoiceConfigCol
            size="8"
            title="Delivery Comment"
            value=
            {deliveryCndCard?.titan_extra_fields?.delivery_comment && deliveryCndCard?.titan_extra_fields?.delivery_comment?.length > 200 ? (
              <div>
                {showMore[deliveryCndCard?.id] && showMore[deliveryCndCard?.id] ? (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: deliveryCndCard?.titan_extra_fields?.delivery_comment.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(deliveryCndCard.id); }} >
                      less
                    </a>
                  </span>
                ) : (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: deliveryCndCard?.titan_extra_fields?.delivery_comment.substring(0, 190).replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(deliveryCndCard.id); }} >
                      ..more
                    </a>
                  </span>
                )}
              </div>
            ) : (
              <div>
                   {deliveryCndCard?.titan_extra_fields?.delivery_comment ? <span dangerouslySetInnerHTML={{ __html: deliveryCndCard?.titan_extra_fields?.delivery_comment.replace(/\n/g, '<br />') }} />:'--'}
              </div>
            )} 
          />
      </Row>
    </div>
      {editModal.modal ?
        <EditSidebar
          title={`Edit Delivery Condition Details`}
          editSideBar={editModal?.modal}
          toggleEditSideBar={() => setEditModal({ modal: false })}
        >
          <EditDeliveryCndCard 
              type="edit"
              deliveryCndCard={deliveryCndCard}
              toggleEditSideBar={() => setEditModal({ modal: false })}
              updateDeliveryCndCard={(data) => updateDeliveryCndCard(data)}
          />
        </EditSidebar> : null}
        {isLoading?<PageLoader/>:null}
    </>
  )
}
